import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  orders: [],
  adminOrders: [],
  error: null,
  adminOrderLoading: false,
};

export const orderReducer = createReducer(initialState, (builder) => {
  builder
    .addCase('getAllOrdersUserRequest', (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase('getAllOrdersUserSuccess', (state, action) => {
      state.isLoading = false;
      state.orders = action.payload;
    })
    .addCase('getAllOrdersUserFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase('getAllOrdersShopRequest', (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase('getAllOrdersShopSuccess', (state, action) => {
      state.isLoading = false;
      state.orders = action.payload;
    })
    .addCase('getAllOrdersShopFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase('adminAllOrdersRequest', (state) => {
      state.adminOrderLoading = true;
      state.error = null;
    })
    .addCase('adminAllOrdersSuccess', (state, action) => {
      state.adminOrderLoading = false;
      state.adminOrders = action.payload; // Cache orders
    })
    .addCase('adminAllOrdersFailed', (state, action) => {
      state.adminOrderLoading = false;
      state.error = action.payload;
    })
    .addCase('clearErrors', (state) => {
      state.error = null;
    });
});

